import React from 'react';
import * as PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import { injectIntl } from 'react-intl';

import Popup from '../Popup';
import TextMessageForm from '../TextMessageForm';
import { BREAKPOINT } from '../../../constants/styles';

const SendMessagePopup = ({
  opened,
  intl: { formatMessage },
  onClose,
  onSubmit,
  title,
}) => {
  return (
    <MediaQuery maxWidth={BREAKPOINT}>
      {isMobile => (
        <Popup
          opened={opened}
          onClose={onClose}
          width={isMobile ? 'medium' : 'small'}
          enabled
          title={title}
        >
          <TextMessageForm
            onSendMessage={onSubmit}
            formatMessage={formatMessage}
            onClose={onClose}
            className="pt3"
          />
        </Popup>
      )}
    </MediaQuery>
  );
};

SendMessagePopup.propTypes = {
  opened: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  title: PropTypes.string,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
};

export default injectIntl(SendMessagePopup);



// WEBPACK FOOTER //
// ./src/components/common/SendMessagePopup/index.jsx